module.exports = __webpack_public_path__ + "img/crowd0.5c975d72.jpg";